var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.5C30 20.09 27.09 23 23.5 23C23.33 23 23.15 22.99 22.98 22.98C22.73 19.81 20.19 17.27 17.02 17.02C17.01 16.85 17 16.67 17 16.5C17 12.91 19.91 10 23.5 10C27.09 10 30 12.91 30 16.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23.5C23 27.09 20.09 30 16.5 30C12.91 30 10 27.09 10 23.5C10 19.91 12.91 17 16.5 17C16.67 17 16.85 17.01 17.02 17.02C20.19 17.27 22.73 19.81 22.98 22.98C22.99 23.15 23 23.33 23 23.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.59 10H11C10.45 10 10 10.45 10 11V13.59C10 14.48 11.08 14.93 11.71 14.3L14.3 11.71C14.92 11.08 14.48 10 13.59 10Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4102 30H29.0002C29.5502 30 30.0002 29.55 30.0002 29V26.41C30.0002 25.52 28.9202 25.07 28.2902 25.7L25.7002 28.29C25.0802 28.92 25.5202 30 26.4102 30Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairAnalytics);
export default __webpack_public_path__ + "static/media/pair_analytics.66cff870f021dca90a0fad42a53db8d4.svg";
export { ForwardRef as ReactComponent };